(function () {
  var root = document.getElementById('faateh-reviews');
  if (!root) return;

  var config = window.faatehReviewsConfig || {};
  var toggleBtn = document.getElementById('faateh-reviews-toggle');
  var form = document.getElementById('faateh-reviews-form');
  var statusEl = document.getElementById('faateh-reviews-status');
  var submitBtn = document.getElementById('faateh-reviews-submit');

  var MAX_PHOTOS = 3;
  var MAX_PHOTO_BYTES = 5 * 1024 * 1024;
  var photoDataUrls = []; // base64 data URLs staged for upload

  if (toggleBtn && form) {
    toggleBtn.addEventListener('click', function () {
      var isHidden = form.hasAttribute('hidden');
      if (isHidden) {
        form.removeAttribute('hidden');
        toggleBtn.textContent = 'Cancel';
        form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        form.setAttribute('hidden', '');
        toggleBtn.textContent = 'Write a Review';
      }
    });
  }

  // The compact rating badge under the product title links to #faateh-reviews.
  // When there are zero reviews yet, clicking it should also pop the form open,
  // not just scroll down to an empty section.
  document.querySelectorAll('[data-open-write="true"]').forEach(function (badge) {
    badge.addEventListener('click', function () {
      if (form && form.hasAttribute('hidden')) {
        form.removeAttribute('hidden');
        if (toggleBtn) toggleBtn.textContent = 'Cancel';
      }
    });
  });

  // Generic star-picker wiring, used for both the main rating and the
  // optional "Fabric Quality" rating.
  function wireStarInput(containerId, hiddenInputId) {
    var container = document.getElementById(containerId);
    var hiddenInput = document.getElementById(hiddenInputId);
    if (!container || !hiddenInput) return;
    var btns = container.querySelectorAll('.faateh-star-btn');

    function paint(value) {
      btns.forEach(function (btn) {
        var v = parseInt(btn.getAttribute('data-value'), 10);
        var path = btn.querySelector('path');
        if (path) path.setAttribute('fill', v <= value ? 'var(--faateh-gold, #B8935B)' : 'none');
      });
    }
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(btn.getAttribute('data-value'), 10);
        hiddenInput.value = v;
        paint(v);
      });
      btn.addEventListener('mouseenter', function () {
        paint(parseInt(btn.getAttribute('data-value'), 10));
      });
    });
    container.addEventListener('mouseleave', function () {
      paint(parseInt(hiddenInput.value, 10) || 0);
    });
  }
  wireStarInput('faateh-star-input', 'faateh-rating-value');
  wireStarInput('faateh-fabric-star-input', 'faateh-fabric-quality-value');

  // Photo upload: read files as base64, show previews, allow removal.
  var photoInputLabel = document.getElementById('faateh-photo-upload-label');
  var photoInput = document.getElementById('faateh-photo-input');
  var photoPreviews = document.getElementById('faateh-photo-previews');

  function renderPhotoPreviews() {
    if (!photoPreviews) return;
    photoPreviews.innerHTML = '';
    photoDataUrls.forEach(function (dataUrl, index) {
      var wrap = document.createElement('div');
      wrap.className = 'faateh-reviews__photo-preview';
      var img = document.createElement('img');
      img.src = dataUrl;
      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'faateh-reviews__photo-remove';
      removeBtn.textContent = '\u00D7';
      removeBtn.addEventListener('click', function () {
        photoDataUrls.splice(index, 1);
        renderPhotoPreviews();
      });
      wrap.appendChild(img);
      wrap.appendChild(removeBtn);
      photoPreviews.appendChild(wrap);
    });
  }

  if (photoInput) {
    photoInput.addEventListener('change', function () {
      var files = Array.prototype.slice.call(photoInput.files || []);
      files.forEach(function (file) {
        if (photoDataUrls.length >= MAX_PHOTOS) {
          setStatus('You can attach up to ' + MAX_PHOTOS + ' photos.', 'error');
          return;
        }
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
          setStatus('Photos must be JPEG, PNG, or WebP.', 'error');
          return;
        }
        if (file.size > MAX_PHOTO_BYTES) {
          setStatus('Each photo must be under 5MB.', 'error');
          return;
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          photoDataUrls.push(e.target.result);
          renderPhotoPreviews();
        };
        reader.readAsDataURL(file);
      });
      photoInput.value = ''; // allow re-selecting the same file later
    });
  }

  function setStatus(message, state) {
    if (!statusEl) return;
    statusEl.textContent = message;
    if (state) {
      statusEl.setAttribute('data-state', state);
    } else {
      statusEl.removeAttribute('data-state');
    }
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!config.endpoint) {
        setStatus('Review submission isn\'t configured yet. Please contact the store.', 'error');
        return;
      }

      var rating = parseInt(document.getElementById('faateh-rating-value').value, 10);
      if (!rating || rating < 1 || rating > 5) {
        setStatus('Please select a star rating.', 'error');
        return;
      }

      var fabricQuality = document.getElementById('faateh-fabric-quality-value').value;
      var isAnonymous = document.getElementById('faateh-review-anonymous')
        ? document.getElementById('faateh-review-anonymous').checked
        : false;

      var payload = {
        productId: config.productId,
        rating: rating,
        title: form.querySelector('#faateh-review-title').value,
        body: form.querySelector('#faateh-review-body').value,
        authorName: form.querySelector('#faateh-review-name').value,
        authorEmail: form.querySelector('#faateh-review-email').value,
        fabricQuality: fabricQuality || undefined,
        isAnonymous: isAnonymous,
        photos: photoDataUrls,
        website: form.querySelector('#faateh-review-website').value // honeypot
      };

      submitBtn.disabled = true;
      setStatus(photoDataUrls.length > 0 ? 'Uploading photos and submitting…' : 'Submitting…', null);

      fetch(config.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          submitBtn.disabled = false;
          if (result.ok && result.data.success) {
            setStatus('Thank you! Your review has been submitted and will appear once approved.', 'success');
            form.reset();
            document.getElementById('faateh-rating-value').value = 0;
            document.getElementById('faateh-fabric-quality-value').value = '';
            photoDataUrls = [];
            renderPhotoPreviews();
            root.querySelectorAll('.faateh-star-btn path').forEach(function (p) {
              p.setAttribute('fill', 'none');
            });
          } else {
            setStatus(result.data.error || 'Something went wrong. Please try again.', 'error');
          }
        })
        .catch(function () {
          submitBtn.disabled = false;
          setStatus('Network error. Please check your connection and try again.', 'error');
        });
    });
  }

  // "Only show reviews with photos" filter on the product page list
  var photoFilter = document.getElementById('faateh-photo-filter');
  var reviewsList = document.getElementById('faateh-reviews-list');
  if (photoFilter && reviewsList) {
    photoFilter.addEventListener('change', function () {
      var items = reviewsList.querySelectorAll('.faateh-reviews__list-item');
      items.forEach(function (item) {
        var hasPhoto = parseInt(item.getAttribute('data-has-photo'), 10) > 0;
        item.style.display = photoFilter.checked && !hasPhoto ? 'none' : '';
      });
    });
  }
})();